import request from '@/utils/request';

// 获得首页类型
export function getHomeApi(params) {
  return request({
    url: '/portal/news-article-category/getHome',
    method: 'get',
    params
  });
}
// 获得文章管理分页
export function getNewsArticleTypeApi(params) {
  return request({
    url: '/portal/news-article/type/page',
    method: 'get',
    params
  });
}

export function getSimpleListApi(params) {
  return request({
    url: '/portal/news-article-category/simple-list',
    method: 'get',
    params
  });
}

 // 轮播
export function getBannerApi(params) {
  return request({
    url: '/portal/banner/List',
    method: 'get',
    params
  });
}
// 获得文章管理
export function getNewsArticleApi (params) {
  return request({
    url: '/portal/news-article/get',
    method: 'get',
    params
  });
}
// banner
export function createMessageApi(data) {
  return request({
    url: '/portal/online-message/create',
    method: 'post',
    data
  });
}
///获得文章 单独只有一个
export function getNewsArticleQueryApi (params) {
  return request({
    url: '/portal/news-article/getQuery',
    method: 'get',
    params
  });
}

///获得基础配置
export function getInfoTypeApi (params) {
  return request({
    url: '/portal/info-configuration/getType',
    method: 'get',
    params
  });
}


///获取模块列表
export function getModuleListApi (params) {
  return request({
    url: '/system/dict-data/module',
    method: 'get',
    params
  });
}
